import { TileRow } from '../tiles/index.js'

const LABEL = {
  light: 'text-[9px] tracking-[1.5px] opacity-70',
  dark: 'text-[8.5px] tracking-[1.5px] opacity-90',
  industry: 'font-heading text-[9px] tracking-[2px] text-accent-700 font-semibold',
}

const GAP = { light: 'gap-[6px]', dark: 'gap-1', industry: 'gap-[5px]' }

export default function DoraChip({ tiles = [], width = 24, theme = 'light', className = '', labelClassName = '' }) {
  const label = LABEL[theme] || LABEL.light
  const gap = GAP[theme] || GAP.light
  return (
    <div className={`inline-flex items-center ${gap} ${className}`}>
      <span className={`${label} ${labelClassName}`}>DORA</span>
      <TileRow tiles={tiles} width={width} />
    </div>
  )
}
